import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '需求定义',
    type: 'BRF_SYS_ACCESS_BRANCH',
}
